import BatchFailures from "./BatchFailures";

export default BatchFailures;
